;(function () {
    function ProductCatalogCardController() {
        /**
         * local object availability
         * @type {navigation}
         * @private
         */
        var _this = this

        /**
         * Current total amount of cards
         * @type {number}
         */
        this.amountOfCards = 0

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.initializeNewCards()

            $(document).on('newResultsAppended', function () {
                _this.initializeNewCards()
            })
        }

        /**
         * Search for all cards and initialize all new cards
         */
        this.initializeNewCards = function () {
            var $allCards = $('.js-product-catalog-card')
            var $changedCards = $allCards.slice(_this.amountOfCards)
            _this.initializeGalleryForCards($changedCards)
            _this.amountOfCards = $allCards.length
        }

        /**
         * Initialize the CardThumbnailGallery for the given cards
         *
         * @param $productCatalogCardElements
         */
        this.initializeGalleryForCards = function ($productCatalogCardElements) {
            if ($productCatalogCardElements.length >= 1) {
                for (var i = 0; i < $productCatalogCardElements.length; i++) {
                    new window.Creaton.productCatalogCardThumbnailGallery($($productCatalogCardElements[i]))
                }
            }
        }

        /**
         * initialize call navigation
         */
        _this.init()
    }

    window.ProductCatalogCardController = window.ProductCatalogCardController || {}

    window.ProductCatalogCardController.ProductCatalogCardController = ProductCatalogCardController
})()

$(document).ready(function () {
    if ($('[rel="search-results--product-list"]').length > 0) {
        new window.ProductCatalogCardController.ProductCatalogCardController()
    }
})
